(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('hero-video');
    const muteButton = document.getElementById('mute-toggle');
    console.log(video)
    // Mute button click event listener
    muteButton.addEventListener('click', function() {
      if (video.muted) {
        video.muted = false;
        muteButton.textContent = '🔇Mute';  // Change button text
      } else {
        video.muted = true;
        muteButton.textContent = '🔊Unmute';  // Change button text
      }
    });
  });

   document.addEventListener("DOMContentLoaded", () => {
      const gmTarget = document.querySelector('.gm-target');

      if (gmTarget) {
        gmTarget.addEventListener('mouseenter', () => {
         
           document.body.style.overflow = 'hidden'; 
        });

        gmTarget.addEventListener('mouseleave', () => {
           document.body.style.overflow = 'auto' // Disable scrolling
        });
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('ed-video');
    const muteButton = document.getElementById('mute-toggle');
    console.log(video)
    // Mute button click event listener
    muteButton.addEventListener('click', function() {
      if (video.muted) {
        video.muted = false;
        muteButton.textContent = '🔇Mute';  // Change button text
      } else {
        video.muted = true;
        muteButton.textContent = '🔊Unmute';  // Change button text
      }
    });
  });

   document.addEventListener("DOMContentLoaded", () => {
      const gmTarget = document.querySelector('.gm-target');

      if (gmTarget) {
        gmTarget.addEventListener('mouseenter', () => {

           document.body.style.overflow = 'hidden';
        });

        gmTarget.addEventListener('mouseleave', () => {
           document.body.style.overflow = 'auto' // Disable scrolling
        });
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["previou-events-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('backgroundVideo');
    const muteButton = document.getElementById('mute-toggle');
    console.log(video)
    // Mute button click event listener
    muteButton.addEventListener('click', function() {
      if (video.muted) {
        video.muted = false;
        muteButton.textContent = '🔇Mute';  // Change button text
      } else {
        video.muted = true;
        muteButton.textContent = '🔊Unmute';  // Change button text
      }
    });
  });

   document.addEventListener("DOMContentLoaded", () => {
      const gmTarget = document.querySelector('.gm-target');

      if (gmTarget) {
        gmTarget.addEventListener('mouseenter', () => {

           document.body.style.overflow = 'hidden';
        });

        gmTarget.addEventListener('mouseleave', () => {
           document.body.style.overflow = 'auto' // Disable scrolling
        });
      }
    });

  } catch(e) { console.error(e); }
})();
})();
